<template>
	<div id="importOrderDialog">
		<el-dialog  :title="isView?'查看订单':'编辑订单'"  :visible.sync="isShowDialog" :width="W?'80%':'80%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="8" style="position:relative">
                        <span class="title texture is-my-required" style="margin-left:30px">订单号：</span>
                        <el-form-item prop="orderCode" class="value" :rules="rules.orderCode" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-input :disabled="isView||addForm.disabled" size="small"   v-model="addForm.orderCode" maxlength="50" placeholder="订单号" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="position:relative">
                        <span class="title is-my-required" style="margin-left:30px">客户名称：</span>
                        <el-form-item class="value" prop="customerId"  :rules="rules.customerId" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select :disabled="isView||addForm.disabled" v-model="addForm.customerId" placeholder="客户名称">
                                <el-option v-for="item in customList" :key="item.id" :label="item.customerName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="position:relative">
                        <span class="title is-my-required" style="margin-left:30px">商标：</span>
                        <el-form-item class="value" prop="customerId" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select :disabled="isView||addForm.disabled" v-model="addForm.customerId" placeholder="商标">
                                <el-option v-for="item in customList" :key="item.id" :label="item.trademark?item.trademark:' '" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">    
                    <el-col :span="8" style="position:relative">
                        <span class="title is-my-required" style="margin-left:30px">签订日期：</span>
                        <el-form-item class="value" prop="orderDate" :rules="rules.orderDate" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-date-picker :disabled="isView||addForm.disabled"  popper-class='timer' v-model="addForm.orderDate" type="date" format="yyyy-MM-dd" placeholder="签订日期" style="width:100%"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="position:relative">
                        <span class="title is-my-required" style="margin-left:30px">交货日期：</span>
                        <el-form-item class="value" prop="deliverDate" :rules="rules.deliverDate"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-date-picker :disabled="isView||addForm.disabled"  popper-class='timer' v-model="addForm.deliverDate" :picker-options= 'pickerOption' type="date" format="yyyy-MM-dd" placeholder="交货日期" style="width:100%"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="position:relative">
                        <span class="title" style="margin-left:30px">包装：</span>
                        <el-form-item class="value" prop="packageType" :rules="rules.packageType" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                           <el-select :disabled="isView||addForm.disabled" clearable v-model="addForm.packageType" placeholder="包装">
                                <el-option label="裸壳" :value="1"></el-option>
                                <el-option label="纸箱" :value="2"></el-option>
                                <el-option label="木箱" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="24" style="position:relative">
                        <span class="title" style="margin-left:30px">技术要求：</span>
                        <el-form-item class="value" prop="technicalSpecification" style="width:85%;">
                            <el-input :disabled="isView||addForm.disabled" size="small" :autosize="{ minRows: 2, maxRows: 3}" type="textarea"  maxlength="255"  :show-word-limit='true'   v-model="addForm.technicalSpecification"  placeholder="技术要求" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" >
                    <el-col :span="24" style="position:relative">
                        <span class="title" style="margin-left:30px;width:70px;">备注：</span>
                        <el-form-item class="value" prop="remark" style="width:85%;">
                            <el-input :disabled="isView||addForm.disabled" size="small" :autosize="{ minRows: 2, maxRows: 3}" type="textarea"  maxlength="255"  :show-word-limit='true'   v-model="addForm.remark"  placeholder="备注" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">
                        <el-button v-show="!isView" type="primary" size="medium" @click="addMaterial()">新增物料</el-button>
                    </el-col>
                </el-row>

                <el-table :data="itemList" :default-expand-all="true" stripe style="width: 100%;margin-bottom:10px;margin-top:10px" class="marterial-table saleOrder">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item style="margin-left:118px;width:94%;">
                                    <el-input :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-model="scope.row.itemRemark" style="width:100%;" maxlength="200" placeholder="请输入备注信息" ></el-input>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column label="序号" min-width="60">
                        <template slot-scope="scope">
                            <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目编号" min-width="110">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-model="scope.row.itemNumber" maxlength="30" placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同序号" min-width="110">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-model="scope.row.contractNumber" maxlength="30" placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="交货日期" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-date-picker :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" popper-class='timer' v-model="scope.row.itemDeliverTime" :picker-options= 'pickerOption' type="date" format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="物料信息" min-width="120">
                        <template slot="header">
                            <span class="is-my-required">物料信息</span>
                        </template>
                        <template slot-scope="scope">
                            <el-form-item :prop="`itemList[${scope.$index}].materialId`" :rules="rules.materialId">
                                <el-select popper-class="width700" :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-model="scope.row.materialId" placeholder="请选择"  @change="materialSelect($event,scope.$index)"
                                    remote filterable :remote-method="(query)=>remoteMethod(query,'',scope.row.itemType,scope.$index)" :loading="loading" >
                                    <el-option v-for="item in materialList[`${scope.$index}`]" :key="item.id"  :value="item.id" :label="`${item.materialCode}  ${item.materialName}`">
                                        <span>{{item.materialCode}}/</span>
                                        <span>{{ item.materialName }}/</span>
                                        <span style="color:red">{{ item.specification }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input disabled v-model="scope.row.specification" placeholder="请输入" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" min-width="100">
                        <template slot="header">
                            <span class="is-my-required">数量</span>
                        </template>
                        <template slot-scope="scope">
                            <el-form-item :prop="`itemList[${scope.$index}].itemCount`" :rules="rules.itemCount">
                                <el-input :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-model="scope.row.itemCount" maxlength="6" placeholder="请输入" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="材质" min-width="100">
                        <template slot="header">
                            <span class="is-my-required">材质</span>
                        </template>
                        <template slot-scope="scope">
                            <el-form-item :prop="`itemList[${scope.$index}].materialQualityName`" :rules="rules.materialQualityName">
                                <el-select filterable :disabled="((isView||addForm.disabled)&&!scope.row.isCreate)||scope.row.hasTexture" v-model="scope.row.materialQualityName" placeholder="请选择" >
                                    <el-option v-for="item in textureList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(item,sIndex) in propertyExtendList" :key="sIndex" :label="item.propertyName" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-if="item.inputType==0" :maxlength="50" v-model="scope.row.orderSplitPropertyExtendList[`${sIndex}`].propertyValue" placeholder="请输入"></el-input>
                                <el-select filterable :disabled="(isView||addForm.disabled)&&!scope.row.isCreate" v-if="item.inputType==1" v-model="scope.row.orderSplitPropertyExtendList[`${sIndex}`].propertyValue" remote placeholder="请选择" clearable>
                                    <el-option v-for="value in item.values" :key="value" :label="value" :value="value"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="备注" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input :disabled="isView" v-model="scope.row.itemRemark" maxlength="200" placeholder="请输入" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column> -->
                    <el-table-column v-show="!isView" label="操作" width="60">
                        <template slot-scope="scope">
                            <div   v-show="showDel(scope.row)" class="delete" type="primary" @click="deleteMaterial(scope.$index)"></div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
			<div v-show="!isView" style="text-align: center;">
                <el-button type="primary" @click="submitAddOrder">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils';

export default {
	name: 'EditOrderDialog',
	props: {
        isShow: Boolean,
        rowData:Object,
        propertyExtendList:Array,
        isView: {
            type: Boolean,
            default: false
        }
	},
	data() {
		return {
            customList:[],
            textureList:[],
            pickerOption:{
                disabledDate(time) {
                    return time.getTime() < Date.now()
                }
            },
            isShowDialog: false,
            addForm:{
                orderCode:'',
                orderDate:'',
                deliverDate:'',
                customerCode:'',
                customerId:'',
                //trademark:'',
                packageType:'',
                technicalSpecification:'',
                remark:'',
                itemList:[],
                disabled:false
            },
            rules:{
                orderCode: [
                    {required: true, message: '请输入订单号', trigger: 'blur'}
                ],
                orderDate: [
                    {required: true, message: '请选择签订日期', trigger: 'blur'}
                ],
                deliverDate: [
                    {required: true, message: '请选择交货日期', trigger: 'blur'}
                ],
                customerId: [
                    {required: true, message: '请输入客户名称', trigger: 'blur'}
                ],
                customerCode: [
                    {required: true, message: '请输入客户编号', trigger: 'blur'}
                ],
                itemType: [
                    {required: true, message: '请选择物料类型', trigger: 'blur'}
                ],
                materialId: [
                    {required: true, message: '请选择物料', trigger: ['blur','change']}
                ],
                materialQualityName:[
                    {required: true, message: '请输入材质', trigger: ['blur','change']}
                ],
                itemCount: [
                    {required: true, message: '请输入数量', trigger: ['blur','change']},
                    {
                        validator(rule, item, callback) {
                            let value = item
                            if (Number(value) > 0) {
                                callback()
                            } else {
                                callback(new Error('数量必须大于零'))
                            }
                        }, trigger: ['blur','change']
                    }
                ],
            },
            itemList:[],
            W:true,
            loading:false,
            materialList:[],
            materialBaseList:[]
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
        this.materialBaseList = await this.loadMaterialList()
        this.getCustomList()
        this.loadTextureList()
        
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        getCustomList(){
            this.$RequestUtil.get({
                url: "/api/customer/list",
                type: "sync",
                params: {},
                success: res => {
                    if (res.code == 0) {
                        this.customList = res.data
                    } else {
                        this.$message.error(res.msg || res.message);
                    }
                }
            });
        },
        async loadTextureList(){
            let {data} = await this.$RequestUtil.getAsync({url: '/api/masterData/material-quality/list',params:{}})
            this.textureList = data
        },
        submitAddOrder(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    let len = this.addForm.itemList.length
                    if(len==0){
                        this.$message.warning('订单物料不能为空，请添加物料')
                        return
                    }
                    log(this.addForm.itemList,'this.addForm.itemList')
                    //检验物料是否重复
                    // let arr = this.addForm.itemList.map(item=>item.materialId)
                    // arr = [...new Set(arr)]
                    // if(arr.length<len){
                    //     this.$message.error('订单物料不能重复，请重新选择重复物料')
                    //     return
                    // }

                    this.addForm.orderId = this.addForm.id
                    this.$RequestUtil.post({
                        url: '/api/order/updateOrder',
                        type: 'sync',
                        params: this.addForm,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('编辑成功')
                                this.cancelAddDialog()
                                this.$parent.reload();
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })

                }
            })
        },

		cancelAddDialog() {
            this.addForm = {
                orderCode:'',
                orderDate:'',
                deliverDate:'',
                customerCode:'',
                customerId:'',
                //trademark:'',
                packageType:'',
                technicalSpecification:'',
                remark:'',
                itemList:[],
            }
            this.itemList = []
            this.isShowDialog = false
            this.$parent.showEditOrderView = false
        },

        addMaterial(){
            let len = this.itemList.length
            //this.itemList.push({})
            let orderSplitPropertyExtendList = this.propertyExtendList.map(item=>{
                return {
                    propertyExtendId:item.id,
                    propertyName:item.propertyName,
                    propertyValue:item.propertyValue
                }
            })
            this.itemList.push({
                orderSplitPropertyExtendList,
                hasTexture:false,
                isCreate:true
            })
            this.materialList[len] = CommonUtils.cloneObj(this.materialBaseList) 
            this.addForm.itemList = this.itemList
        },
        
        deleteMaterial(index){
            this.itemList.splice(index, 1)
            this.materialList.splice(index, 1)
        },

        async loadMaterialList(webSearchStr,materialCode,itemType){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listMaterial',type:'async',params: {webSearchStr,materialCode,itemType,isTechnology:true}})
            if(code==0){
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod(materialName,materialCode,itemType,index) {
            this.loading = true;
            this.materialList[index]  = await this.loadMaterialList(materialName,materialCode,itemType)
            this.loading = false
        },

        materialTypeChange(ev,index){
            this.$set(this.itemList[index],'materialId',null)
            this.remoteMethod('','',ev,index)
        },

        materialSelect(ev,index){
            this.$set(this.itemList[index],'hasTexture',false)
            if(ev){
                let find = this.materialList[index].find(item=>item.id==ev)
                if(find){
                   this.$set(this.itemList[index],'itemType',find.itemType)
                   this.$set(this.itemList[index],'specification',find.specification)
                    if(find.materialQualityName){
                        this.$set(this.itemList[index],'materialQualityName',find.materialQualityName)
                        this.$set(this.itemList[index],'hasTexture',true)
                    }
                }
            }
        },
        showDel(row){
            if(this.isView){
                return false
            }else{
                if(this.addForm.businessState==1){
                    return true
                }else if(this.addForm.businessState==2||this.addForm.businessState==3){
                    if(row.isCreate){
                        return true
                    }else{
                      return false
                    }
                }else{
                  return false
                }
            }
        }
	},

	watch: {
		"isShow": function (newVal, oldVal) {
            this.isShowDialog = this.isShow;
            if(this.isShow){
                this.addForm = commonUtils.cloneObj(this.rowData)
                if(this.addForm.businessState==2||this.addForm.businessState==3){
                    this.addForm.disabled = true
                }
                this.addForm.itemList.forEach(sub=>{
                    let arr = []
                    this.propertyExtendList.forEach(item=>{
                        let find = sub.orderSplitPropertyExtendList.find(f=>item.id==f.propertyExtendId)
                        if(find){
                            arr.push(find)
                        }else{
                            let cloneData = commonUtils.cloneObj(item)
                            cloneData.propertyExtendId = cloneData.id
                            delete cloneData.id
                            cloneData.businessOrderItemId = sub.id
                            arr.push(cloneData)
                        }
                        
                    })
                    sub.orderSplitPropertyExtendList = arr
                })
                
               
                this.itemList = this.addForm.itemList
                
                // this.addForm.orderDate = this.addForm.orderTime
                
                // this.addForm.deliverDate = this.addForm.deliverTime
                // this.addForm.customerId = this.addForm.ordercustomerId
                // this.addForm.customerCode = this.addForm.orderCustomerCode

                this.$set(this.addForm,'orderDate',this.addForm.orderTime)
                this.$set(this.addForm,'deliverDate',this.addForm.deliverTime)
                //this.$set(this.addForm,'customerId',this.addForm.customerId)
                //this.$set(this.addForm,'customerCode',this.addForm.orderCustomerCode)
                this.itemList.forEach((item,index)=>{
                    let find = this.materialBaseList.find(sub=>sub.id == item.materialId)
                    this.materialList[index] = commonUtils.cloneObj(this.materialBaseList)
                    
                    if(!find){
                        this.materialList[index].push({
                            materialCode : item.materialCode,
                            materialName : item.materialName,
                            itemType : item.itemType,
                            id : item.materialId,
                            specification:item.specification,
                            materialQualityName:item.materialQualityName
                        })
                    }else{
                        // if(find.materialQualityName){
                        //    item.hasTexture = true
                        // }
                    }
                })
            }
		},
	},
}
</script>
<style scoped>
    .is-my-required:before {
        content: '*';
        color: #F56C6C;
        left: 32px;
        top: 6px;
        font-size: 20px;
        position: absolute
    }
    .texture.is-my-required:before{
        left: 45px;
    }
    .marterial-table .is-my-required:before{
        left: 0px;
        top: 3px
    }
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('/static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {
        background-image: url('/static/img/del-hover.png');
        background-repeat: no-repeat;
    }
    .title {
            color: #606266;
            font-family: NotoSansHans-Regula;
            font-size: 14px;
            display: inline-block;
            text-align: right;
            /* width: 70px; */
        }

        .value {
            display: inline-block
        }

    @media screen and (min-width: 1300px) and (max-width: 1930px){
    
    }
</style>
<style>
.saleOrder .el-form-item__content{
    width: 100%;
}
#importOrderDialog .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border: none;
}
.width700{
    max-width:700px;
    height: 400px;
}
.width700 .el-select-dropdown__wrap{
    max-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/EditOrderDialog.vue